import React from 'react';

import win from '../../../shared/win';

import { BannerWrapper, ContentBox, LogoBox } from './styled';

const { PLAN: { is_trail = false, is_free = false } = {} } = win || {};

const CreateFormBanner = ({ isLinkActive = true }) => {
  if (!(is_free || is_trail)) return null;

  return (
    <BannerWrapper>
      <LogoBox>
        <a href={isLinkActive ? '/' : undefined} class="logo">
          <img src="/static/images/logo/formplus-logo.png" id="formplus-logo" alt="Formplus Logo" />
        </a>
      </LogoBox>

      <ContentBox>
        <p>Now create your own form — it’s free!</p>
        <a
          href={isLinkActive ? 'https://formpl.us' : undefined}
          target={isLinkActive ? '_blank' : undefined}
          rel="noopener noreferrer">
          Create your own form
        </a>
      </ContentBox>
    </BannerWrapper>
  );
};

export default CreateFormBanner;